import { useRoute } from "../router";

interface Counts { monitor: number; issues: number }

export function BrandRail({ counts }: { counts: Counts }) {
  const [route] = useRoute();

  const getLinkClass = (name: string) => {
    const base = "font-mono text-t-12 uppercase tracking-[0.15em] px-2.5 py-2 border flex justify-between items-baseline transition-all duration-[80ms]";
    const isActive = route.name === name;
    return isActive
      ? `${base} bg-fg text-bg border-fg`
      : `${base} border-transparent hover:border-fg text-fg`;
  };

  return (
    <aside className="brand-rail border-r border-fg p-6 flex flex-col" aria-label="Primary navigation">
      <div className="font-display font-extrabold text-t-26 leading-[0.95] tracking-[-0.025em]">
        skill<small className="block font-mono text-[10px] font-normal tracking-[0.14em] uppercase mt-1.5 text-muted">// grinder</small>
      </div>
      <nav className="mt-9 flex flex-col gap-1.5">
        <a href="#/dashboard" className={getLinkClass("dashboard")}>
          <span>Dashboard</span>
          <span className={route.name === "dashboard" ? "font-normal" : "text-muted font-normal"}>·</span>
        </a>
        <a href="#" className={getLinkClass("monitor")}>
          <span>Monitor</span>
          <span className="font-normal">{counts.monitor}</span>
        </a>
        <a href="#/history" className={getLinkClass("history")}>
          <span>History</span>
          <span className={route.name === "history" ? "font-normal" : "text-muted font-normal"}>·</span>
        </a>
        <a href="#/runs" className={getLinkClass("runs")}>
          <span>Runs</span>
          <span className={route.name === "runs" ? "font-normal" : "text-muted font-normal"}>·</span>
        </a>
        <a href="#/guide" className={getLinkClass("guide")}>
          <span>Guide</span>
          <span className={route.name === "guide" ? "font-normal" : "text-muted font-normal"}>·</span>
        </a>
        <a href="#/insights" className={getLinkClass("insights")}>
          <span>Insights</span>
          <span className={route.name === "insights" ? "font-normal" : "text-muted font-normal"}>·</span>
        </a>
        <a href="#/workbench" className={getLinkClass("workbench")}>
          <span>Workbench</span>
          <span className={route.name === "workbench" ? "font-normal" : "text-muted font-normal"}>·</span>
        </a>
        <a href="#/graph" className={getLinkClass("graph")}>
          <span>Graph</span>
          <span className={route.name === "graph" ? "font-normal" : "text-muted font-normal"}>·</span>
        </a>
      </nav>
      <footer className="mt-auto font-mono text-[10px] tracking-[0.1em] uppercase text-muted border-t border-fg pt-4 leading-[1.6]">
        Edition 01<br/>v0.1
      </footer>
    </aside>
  );
}
